import {
    DefaultButton,
    Dialog,
    DialogFooter,
    DialogType,
    MessageBar,
    MessageBarType,
    Spinner,
    SpinnerSize,
    Stack
} from "@fluentui/react";

import React, {useEffect} from "react";

import {ISectionToTemplateRequest} from "../../models/Storefront";
import DataField from "../Common/DataField";
import {useCreateStorefrontSectionTemplateMutation} from "../../store/endpoints/StorefrontSectionEndpoints";
import ToggleField from "../Common/ToggleField";

interface IStorefrontSectionSaveTemplateModalProps {
    sectionId: string;
    title?: string;
    storefrontId: string;
    displayModal: boolean;
    closer: () => void;
}

const StorefrontSectionSaveTemplateModal: React.FC<IStorefrontSectionSaveTemplateModalProps> = props => {
    const [request, setRequest] = React.useState<ISectionToTemplateRequest>({});
    const [saveMessage, setSaveMessage] = React.useState<string | undefined>();
    const [saving, setSaving] = React.useState(false);
    useEffect(() => {
        setRequest({...request, storefront: props.storefrontId, existingId: props.sectionId, newTitle: props.title});
    }, [props.sectionId, props.storefrontId, props.title])
    
    const [saveToTemplate] = useCreateStorefrontSectionTemplateMutation()
    return (
        <Dialog
            hidden={!props.displayModal}
            onDismiss={props.closer}
            dialogContentProps={{
                type: DialogType.largeHeader,
                title: 'Create Section Template',
            }}
            modalProps={{
                isBlocking: true,
            }}
        >
            {saveMessage && <MessageBar messageBarType={MessageBarType.error}>{saveMessage}</MessageBar>}
            {saving && <Spinner size={SpinnerSize.large} label={'Saving'}></Spinner>}
            <Stack>
                <DataField 
                    value={request.newTitle} 
                    label={'Title'}
                    onChange={(e, v) => {setRequest({...request, newTitle: v})}} 
                    disabled={saving} 
                    onKeyDown={(e) => {if(e.key === "Enter"){
                        setSaving(true)
                        saveToTemplate({request}).unwrap().then((resp) => {
                            setSaving(false)
                            if(resp.success){
                                props.closer()
                            }
                            else{
                                setSaveMessage(resp.message ?? 'Save to template failed')
                            }
                        })
                    }}}
                />
                <ToggleField label={'Private'} inline={true} checked={request.makePrivate} onChange={(v) => setRequest({...request, makePrivate: !!v})} disabled={saving} />
            </Stack>
            <DialogFooter>
                <DefaultButton
                    disabled={saving}
                    primary={true}
                    text='Ok'
                    onClick={() => {
                        setSaving(true)
                        saveToTemplate({request}).unwrap().then((resp) => {
                            setSaving(false)
                            if(resp.success){
                                props.closer()
                            }
                            else{
                                setSaveMessage(resp.message ?? 'Save to template failed')
                            }
                        })
                    }}
                />
                <DefaultButton
                    disabled={saving}
                    text='Cancel'
                    onClick={props.closer}
                />
            </DialogFooter>
        </Dialog>
    );
}
export default StorefrontSectionSaveTemplateModal;